import { useCallback } from "react";

import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { errorMessage } from "@/api/errors";

/** Mutatsiya xatosini lug'atdagi matn bilan ko'rsatadi. */
export function useErrorToast() {
  const { t, i18n } = useTranslation();
  return useCallback(
    (error: unknown) => {
      toast.error(
        errorMessage(
          error,
          (key, values) => t(key, values),
          key => i18n.exists(key),
        ),
      );
    },
    [t, i18n],
  );
}
